import { Text } from 'app/design/primitives/text';
import type { Theme } from 'app/shopify';
import { useTheme } from '@shopify/restyle';
import { Trans } from 'react-i18next';
import { View } from 'react-native';
import type { getDonationTextForOverlay } from './listing-thumbnail';

export function ListingThumbnailDonationOverlay({
  overlay,
  size,
}: {
  overlay: ReturnType<typeof getDonationTextForOverlay> | null;
  size: number;
}) {
  const theme = useTheme<Theme>();
  if (!overlay) return null;
  return (
    <View
      style={{
        position: 'absolute',
        bottom: (4 / 100) * size,
        right: (4 / 100) * size,
        backgroundColor: theme.colors['surface.brand.secondary-4.subtle'],
        paddingVertical: 4,
        paddingHorizontal: 8,
        borderRadius: 10,
      }}
    >
      <Text fontSize={10}>
        <Trans
          components={{ strong: <Text fontWeight="700" /> }}
          count={overlay.i18nValues.count}
          i18nKey={overlay.i18key}
          ns="common"
        />
      </Text>
    </View>
  );
}
